// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import SimpleBar from "simplebar-react";
// import { useSelector } from "react-redux";
// import { createSelector } from 'reselect';

// //import logo
// import avatar1 from "../assets/images/profile.jpg";
// import companyLogo from "../assets/images/xenthr.png";

// //Import Components
// import VerticalLayout from "./VerticalLayouts";
// import TwoColumnLayout from "./TwoColumnLayout";
// import { Container, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
// import HorizontalLayout from "./HorizontalLayout";

// // Get company name from environment variables
// const COMPANY_NAME = process.env.REACT_APP_COMPANY_TITLE || 'VSR Company Payroll';

// const Sidebar = ({ layoutType }: any) => {
//   const [logoError, setLogoError] = useState<boolean>(false);

//   // Selector for user data
//   const selectUserData = createSelector(
//     (state: any) => state.login,
//     (login: any) => ({
//       user: login?.user || null,
//     })
//   );

//   const { user } = useSelector(selectUserData);

//   useEffect(() => {
//     var verticalOverlay = document.getElementsByClassName("vertical-overlay");
//     if (verticalOverlay) {
//       verticalOverlay[0].addEventListener("click", function () {
//         document.body.classList.remove("vertical-sidebar-enable");
//       });
//     }
//   }, []);

//   const addEventListenerOnSmHoverMenu = () => {
//     // add listener Sidebar Hover icon on change layout from setting
//     if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
//       document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
//     } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
//       document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
//     } else {
//       document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
//     }
//   };

//   // Get user name
//   const getUserName = () => {
//     if (user?.name) return user.name;
//     if (user?.username) return user.username;
//     if (user?.email) return user.email.split('@')[0];
//     return 'User';
//   };

//   // Get user avatar
//   const getUserAvatar = () => {
//     return user?.avatar || avatar1;
//   };

//   // Handle logo load error
//   const handleLogoError = () => {
//     setLogoError(true);
//   };

//   return (
//     <React.Fragment>
//       <div className="app-menu navbar-menu">
//         <div className="navbar-brand-box" style={{ padding: '0px 0rem' }}>
//           {/* Company logos - keep sidebar layout unchanged */}
//           <Link
//             to="/"
//             className="logo logo-dark"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               width: '100%',
//               height: '100%',
//               textDecoration: 'none',
//             }}
//           >
//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: '100%',
//                 height: '100%',
//                 gap: '12px',
//               }}
//             >
//               {/* Current company logo */}
//               <img
//                 src={companyLogo}
//                 alt={COMPANY_NAME}
//                 style={{
//                   width: 'auto',
//                   height: '40px',
//                   maxWidth: '45%',
//                   objectFit: 'contain',
//                 }}
//                 onError={handleLogoError}
//               />

//               {/* Vertical divider */}
//               <div
//                 style={{
//                   width: '1px',
//                   height: '32px',
//                   backgroundColor: 'rgba(128, 128, 128, 0.5)',
//                   flexShrink: 0,
//                 }}
//               />

//               {/* MC logo */}
//               <img
//                 src="/mc.png"
//                 alt="MC"
//                 style={{
//                   width: 'auto',
//                   height: '40px',
//                   maxWidth: '45%',
//                   objectFit: 'contain',
//                 }}
//               />
//             </div>
//           </Link>

//           <Link
//             to="/"
//             className="logo logo-light"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               width: '100%',
//               height: '100%',
//               textDecoration: 'none',
//             }}
//           >
//             <div
//               style={{
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: '100%',
//                 height: '100%',
//                 gap: '12px',
//               }}
//             >
//               {/* Current company logo */}
//               <img
//                 src={companyLogo}
//                 alt={COMPANY_NAME}
//                 style={{
//                   width: 'auto',
//                   height: '40px',
//                   maxWidth: '45%',
//                   objectFit: 'contain',
//                 }}
//                 onError={handleLogoError}
//               />

//               {/* Vertical divider */}
//               <div
//                 style={{
//                   width: '1px',
//                   height: '32px',
//                   backgroundColor: 'rgba(128, 128, 128, 0.5)',
//                   flexShrink: 0,
//                 }}
//               />

//               {/* MC logo */}
//               <img
//                 src="/mc.png"
//                 alt="MC"
//                 style={{
//                   width: 'auto',
//                   height: '40px',
//                   maxWidth: '45%',
//                   objectFit: 'contain',
//                 }}
//               />
//             </div>
//           </Link>

//           <button
//             onClick={addEventListenerOnSmHoverMenu}
//             type="button"
//             className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
//             id="vertical-hover"
//           >
//             <i className="ri-record-circle-line"></i>
//           </button>
//         </div>

//         {/* User Profile Dropdown - Dynamic */}
//         <UncontrolledDropdown className="sidebar-user m-1 rounded">
//           <DropdownToggle tag="button" type="button" className="btn material-shadow-none" id="page-header-user-dropdown">
//             <span className="d-flex align-items-center gap-2">
//               <img
//                 className="rounded header-profile-user"
//                 src={getUserAvatar()}
//                 alt={getUserName()}
//                 style={{ width: '32px', height: '32px', objectFit: 'cover' }}
//                 onError={(e) => {
//                   (e.target as HTMLImageElement).src = avatar1;
//                 }}
//               />
//               <span className="text-start">
//                 <span className="d-block fw-medium sidebar-user-name-text">{getUserName()}</span>
//                 <span className="d-block fs-14 sidebar-user-name-sub-text">
//                   <i className="ri ri-circle-fill fs-10 text-success align-baseline"></i>
//                   <span className="align-middle">Online</span>
//                 </span>
//               </span>
//             </span>
//           </DropdownToggle>

//           <DropdownMenu className="dropdown-menu-end">
//             <h6 className="dropdown-header">Welcome {getUserName()}!</h6>

//             <Link to="/profile" className="dropdown-item">
//               <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Profile</span>
//             </Link>

//             <Link to="/apps-chat" className="dropdown-item">
//               <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Messages</span>
//             </Link>

//             <Link to="/apps-tasks-kanban" className="dropdown-item">
//               <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Taskboard</span>
//             </Link>

//             <Link to="/pages-faqs" className="dropdown-item">
//               <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Help</span>
//             </Link>

//             <div className="dropdown-divider"></div>

//             <Link to="/pages-profile-settings" className="dropdown-item">
//               <span className="badge bg-success-subtle text-success mt-1 float-end">New</span>
//               <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Settings</span>
//             </Link>

//             <Link to="/auth-lockscreen-basic" className="dropdown-item">
//               <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Lock screen</span>
//             </Link>

//             <Link to="/auth-logout-basic" className="dropdown-item">
//               <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
//               <span className="align-middle">Logout</span>
//             </Link>
//           </DropdownMenu>
//         </UncontrolledDropdown>

//         {/* Navigation Menus based on layout type */}
//         {layoutType === "horizontal" ? (
//           <div id="scrollbar">
//             <Container fluid>
//               <div id="two-column-menu"></div>
//               <ul className="navbar-nav" id="navbar-nav">
//                 <HorizontalLayout />
//               </ul>
//             </Container>
//           </div>
//         ) : layoutType === 'twocolumn' ? (
//           <React.Fragment>
//             <TwoColumnLayout layoutType={layoutType} />
//           </React.Fragment>
//         ) : (
//           <React.Fragment>
//             <SimpleBar id="scrollbar" className="h-100">
//               <Container fluid>
//                 <div id="two-column-menu"></div>
//                 <ul className="navbar-nav" id="navbar-nav">
//                   <VerticalLayout layoutType={layoutType} />
//                 </ul>
//               </Container>
//             </SimpleBar>
//           </React.Fragment>
//         )}
//       </div>
//       <div className="vertical-overlay"></div>
//     </React.Fragment>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';

//import logo
import avatar1 from "../assets/images/profile.jpg";
import companyLogo from "../assets/images/xenthr.png";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import TwoColumnLayout from "./TwoColumnLayout";
import { Container, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";

// Get company name from environment variables
const COMPANY_NAME = process.env.REACT_APP_COMPANY_TITLE || 'VSR Company Payroll';

const Sidebar = ({ layoutType }: any) => {
  const [logoError, setLogoError] = useState<boolean>(false);
  const [mcLogoError, setMcLogoError] = useState<boolean>(false);

  // Selector for user data
  const selectUserData = createSelector(
    (state: any) => state.login,
    (login: any) => ({
      user: login?.user || null,
    })
  );

  const { user } = useSelector(selectUserData);

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  }, []);

  const addEventListenerOnSmHoverMenu = () => {
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  // Get user name
  const getUserName = () => {
    if (user?.name) return user.name;
    if (user?.username) return user.username;
    if (user?.email) return user.email.split('@')[0];
    return 'User';
  };

  // Get user avatar
  const getUserAvatar = () => {
    return user?.avatar || avatar1;
  };

  // Handle logo load error
  const handleLogoError = () => {
    setLogoError(true);
  };

  // Handle MC logo load error
  const handleMcLogoError = () => {
    setMcLogoError(true);
  };

  // Logo component with WHITE background always
  const LogoContent = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        gap: '12px',
        backgroundColor: '#ffffff', // ✅ Always white background
        padding: '8px 12px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
      }}
    >
      {/* Current company logo */}
      {!logoError ? (
        <img
          src={companyLogo}
          alt={COMPANY_NAME}
          style={{
            width: 'auto',
            height: '40px',
            maxWidth: '45%',
            objectFit: 'contain',
          }}
          onError={handleLogoError}
        />
      ) : (
        <span className="fw-bold fs-5" style={{ color: '#1a1a2e' }}>
          {COMPANY_NAME.charAt(0)}
        </span>
      )}

      {/* Vertical divider */}
      <div
        style={{
          width: '1px',
          height: '32px',
          backgroundColor: '#d1d5db',
          flexShrink: 0,
        }}
      />

      {/* MC logo */}
      {!mcLogoError ? (
        <img
          src="/mc.png"
          alt="MC"
          style={{
            width: 'auto',
            height: '40px',
            maxWidth: '45%',
            objectFit: 'contain',
          }}
          onError={handleMcLogoError}
        />
      ) : (
        <span className="fw-bold fs-5" style={{ color: '#6b7280' }}>
          MC
        </span>
      )}
    </div>
  );

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div className="navbar-brand-box" style={{ padding: '0px 0rem' }}>
          {/* Single logo container - always white background */}
          <Link
            to="/"
            className="logo"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              textDecoration: 'none',
            }}
          >
            <LogoContent />
          </Link>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line"></i>
          </button>
        </div>

        {/* User Profile Dropdown - Dynamic */}
        <UncontrolledDropdown className="sidebar-user m-1 rounded">
          <DropdownToggle tag="button" type="button" className="btn material-shadow-none" id="page-header-user-dropdown">
            <span className="d-flex align-items-center gap-2">
              <img
                className="rounded header-profile-user"
                src={getUserAvatar()}
                alt={getUserName()}
                style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = avatar1;
                }}
              />
              <span className="text-start">
                <span className="d-block fw-medium sidebar-user-name-text">{getUserName()}</span>
                <span className="d-block fs-14 sidebar-user-name-sub-text">
                  <i className="ri ri-circle-fill fs-10 text-success align-baseline"></i>
                  <span className="align-middle">Online</span>
                </span>
              </span>
            </span>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu-end">
            <h6 className="dropdown-header">Welcome {getUserName()}!</h6>

            <Link to="/profile" className="dropdown-item">
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Profile</span>
            </Link>

            <Link to="/apps-chat" className="dropdown-item">
              <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Messages</span>
            </Link>

            <Link to="/apps-tasks-kanban" className="dropdown-item">
              <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Taskboard</span>
            </Link>

            <Link to="/pages-faqs" className="dropdown-item">
              <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Help</span>
            </Link>

            <div className="dropdown-divider"></div>

            <Link to="/pages-profile-settings" className="dropdown-item">
              <span className="badge bg-success-subtle text-success mt-1 float-end">New</span>
              <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Settings</span>
            </Link>

            <Link to="/auth-lockscreen-basic" className="dropdown-item">
              <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Lock screen</span>
            </Link>

            <Link to="/auth-logout-basic" className="dropdown-item">
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Logout</span>
            </Link>
          </DropdownMenu>
        </UncontrolledDropdown>

        {/* Navigation Menus based on layout type */}
        {layoutType === "horizontal" ? (
          <div id="scrollbar">
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <HorizontalLayout />
              </ul>
            </Container>
          </div>
        ) : layoutType === 'twocolumn' ? (
          <React.Fragment>
            <TwoColumnLayout layoutType={layoutType} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <SimpleBar id="scrollbar" className="h-100">
              <Container fluid>
                <div id="two-column-menu"></div>
                <ul className="navbar-nav" id="navbar-nav">
                  <VerticalLayout layoutType={layoutType} />
                </ul>
              </Container>
            </SimpleBar>
          </React.Fragment>
        )}
      </div>
      <div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default Sidebar;